export default __webpack_public_path__ + "static/media/bubble_nova_m3.fb2672b3.png";